var map = {
	"./admin_new.png": "45c5",
	"./background.png": "9855",
	"./not_found.png": "5abe",
	"./notnull.png": "c59e",
	"./pk.png": "b3ed",
	"./shang.png": "4cb3",
	"./systemSetupMenu.png": "7b61",
	"./tree/bayonet.png": "fd0a",
	"./tree/database.png": "38a0",
	"./tree/table.png": "0c1b",
	"./tree/tree.png": "fcc3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";